<div class="dashboard">
  @if (selectedValue$ | async; as selectedValue) {
    <div class="dashboard__header">
      <app-custom-objects-dashboard-header
        [customObjectValue]="selectedValue"
        (changeLayout)="onChangeLayout(selectedValue)"
      ></app-custom-objects-dashboard-header>
    </div>
  } @else {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <router-outlet></router-outlet>
</div>
